<footer class="footer">
<div class="container-fluid">
    <div class="row">
        <div class="col-md-1">
            <img class="" src="assets/images/banco-falabella-dark.png" />
        </div>
        <div class="col-md-5 text-left">
            <span class="footer-text">© Banco Falabella 2020. Todos los derechos reservados</span>
            
        </div>
        <div class="col-md-6">
            <span class="footer-text">Si tenes alguna duda o consulta sobre tus productos ingresa a </span>
            <a href="https://www.bancofalabella.pe" target="_blank">www.bancofalabella.pe</a>
        </div>
    </div>
</div>
</footer>